import * as React from 'react';

import PropTypes from 'prop-types';

/** AI-Generated Documentation - Please Read with Caution */

/** A customizable checkbox component with optional label. */
class Checkbox extends React.Component {
  static propTypes = {
    /** Text label displayed next to the checkbox */
    label: PropTypes.string,
    /** Event handler called when the checkbox state changes */
    onChange: PropTypes.func,
    /** When true, the checkbox cannot be interacted with */
    disabled: PropTypes.bool,
    /** When true, the checkbox is marked as selected */
    checked: PropTypes.bool,
    /** Custom styles to apply to the outer label element */
    style: PropTypes.object,
    /** Additional CSS class names to apply to the label element */
    className: PropTypes.string,
    /** Optional child elements to render after the checkbox */
    children: PropTypes.object,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'label' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { label, disabled, checked, onChange, style, className, children } = this.props;
    // const className = 'btn btn-default';

    return (
      <label htmlFor="checkbox" className={className} style={style}>
        <input
          type="checkbox"
          style={{ margin: 0, padding: 0, verticalAlign: 'middle' }}
          value={label}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        {label && <span>{label}</span>}
        {children}
      </label>
    );
  }
}

export default Checkbox;
